import { render, staticRenderFns } from "./Atlas.vue?vue&type=template&id=44cebcdf&scoped=true&"
import script from "./Atlas.vue?vue&type=script&lang=js&"
export * from "./Atlas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cebcdf",
  null
  
)

export default component.exports